import * as React from "react";

import { MeetingInterpretation } from "@/api/types";

/** A compact "meeting so far" card of the agent's parsed interpretation. */
export function MeetingContextCard({ interp }: { interp: MeetingInterpretation }) {
  const rows: { label: string; value: string }[] = [];

  if (interp.participants && interp.participants.length > 0) {
    rows.push({ label: "With", value: interp.participants.join(", ") });
  }

  const start = fmtDate(interp.start);
  const end = fmtDate(interp.end);
  const span = start && end && end !== start ? `${start} – ${end}` : start ?? null;
  if (interp.weekdays && interp.weekdays.length > 0) {
    rows.push({
      label: "When",
      value: interp.weekdays.join(" or ") + (span ? ` (${span})` : ""),
    });
  } else if (span) {
    rows.push({ label: "When", value: span });
  }

  if (interp.time_of_day) {
    rows.push({ label: "Time", value: interp.time_of_day });
  }
  if (interp.duration_minutes) {
    rows.push({ label: "Duration", value: fmtDuration(interp.duration_minutes) });
  }
  if (interp.subject) {
    rows.push({ label: "About", value: interp.subject });
  }

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="comic-shadow rounded-md border border-border bg-muted/40 px-3 py-2 text-xs">
      <div className="mb-1 font-display text-xs uppercase tracking-wider text-muted-foreground">
        Meeting so far
      </div>
      <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5">
        {rows.map((r) => (
          <React.Fragment key={r.label}>
            <dt className="text-muted-foreground">{r.label}</dt>
            <dd className="font-medium">{r.value}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
}

function fmtDate(iso?: string | null): string | null {
  if (!iso) {
    return null;
  }
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) {
    return iso;
  }
  return d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
}

function fmtDuration(minutes: number): string {
  if (minutes % 60 === 0) {
    const h = minutes / 60;
    return `${h} ${h === 1 ? "hour" : "hours"}`;
  }
  return `${minutes} minutes`;
}
